import { render, staticRenderFns } from "./ImagingProcedure.vue?vue&type=template&id=426b6ee6&scoped=true"
import script from "./ImagingProcedure.vue?vue&type=script&lang=js"
export * from "./ImagingProcedure.vue?vue&type=script&lang=js"
import style0 from "./ImagingProcedure.vue?vue&type=style&index=0&id=426b6ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426b6ee6",
  null
  
)

export default component.exports